import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-browser-error',
  templateUrl: './browser-error.component.html',
  styleUrls: ['./browser-error.component.css']
})
export class BrowserErrorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
